'use client'

import React from 'react'

import { isSafari } from 'react-device-detect'

const PageTransition = () => {
    return (
        <div id="page-transition" className={isSafari ? 'h-visually-hidden' : 'h-page-animate h-page-animate--in'} >
            <div />
        </div >
    )
}

export default PageTransition